/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Field_Inbound_Delivery_ToInputs */

const en_field_inbound_delivery_to = /** @type {(inputs: Field_Inbound_Delivery_ToInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inbound delivery end`)
};

/**
* | output |
* | --- |
* | "Inbound delivery end" |
*
* @param {Field_Inbound_Delivery_ToInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const field_inbound_delivery_to = /** @type {((inputs?: Field_Inbound_Delivery_ToInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Field_Inbound_Delivery_ToInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_field_inbound_delivery_to(inputs)
});